/**
 * Ticket statüsü → renk/i18n eşlemesi (tek kaynak).
 *
 * Statü rozeti (TicketStatusBadge), durum menüsü (TicketStatusMenu) ve
 * liste filtre çipleri (MyTicketsSection) aynı paletten beslenir; yeni bir
 * statü eklendiğinde yalnızca bu dosya güncellenir.
 */
export interface TicketStatusColor {
  i18nKey: string;
  /** Rozet: arka plan + metin */
  badge: string;
  /** Renk noktası (menü ve çiplerde) */
  dot: string;
  /** Seçili filtre çipi: kenarlık + arka plan + metin */
  activeChip: string;
}

export const TICKET_STATUS_COLORS: Record<string, TicketStatusColor> = {
  open: {
    i18nKey: "support.myTickets.status.open",
    badge: "bg-sky-500/10 text-sky-700 dark:bg-sky-500/15 dark:text-sky-400",
    dot: "bg-sky-500",
    activeChip:
      "border-sky-500/50 bg-sky-500/10 text-sky-700 dark:text-sky-400",
  },
  pending: {
    i18nKey: "support.myTickets.status.pending",
    badge: "bg-sky-500/10 text-sky-700 dark:bg-sky-500/15 dark:text-sky-400",
    dot: "bg-sky-500",
    activeChip:
      "border-sky-500/50 bg-sky-500/10 text-sky-700 dark:text-sky-400",
  },
  in_progress: {
    i18nKey: "support.myTickets.status.inProgress",
    badge:
      "bg-amber-500/10 text-amber-700 dark:bg-amber-500/15 dark:text-amber-400",
    dot: "bg-amber-500",
    activeChip:
      "border-amber-500/50 bg-amber-500/10 text-amber-700 dark:text-amber-400",
  },
  on_hold: {
    i18nKey: "support.myTickets.status.onHold",
    badge:
      "bg-orange-500/10 text-orange-700 dark:bg-orange-500/15 dark:text-orange-400",
    dot: "bg-orange-500",
    activeChip:
      "border-orange-500/50 bg-orange-500/10 text-orange-700 dark:text-orange-400",
  },
  solved: {
    i18nKey: "support.myTickets.status.solved",
    badge:
      "bg-emerald-500/10 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-400",
    dot: "bg-emerald-500",
    activeChip:
      "border-emerald-500/50 bg-emerald-500/10 text-emerald-700 dark:text-emerald-400",
  },
  responded: {
    i18nKey: "support.myTickets.status.responded",
    badge:
      "bg-violet-500/10 text-violet-700 dark:bg-violet-500/15 dark:text-violet-400",
    dot: "bg-violet-500",
    activeChip:
      "border-violet-500/50 bg-violet-500/10 text-violet-700 dark:text-violet-400",
  },
  resolved: {
    i18nKey: "support.myTickets.status.resolved",
    badge:
      "bg-emerald-500/10 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-400",
    dot: "bg-emerald-500",
    activeChip:
      "border-emerald-500/50 bg-emerald-500/10 text-emerald-700 dark:text-emerald-400",
  },
  closed: {
    i18nKey: "support.myTickets.status.closed",
    badge:
      "bg-slate-500/10 text-slate-600 dark:bg-slate-500/15 dark:text-slate-400",
    dot: "bg-slate-500",
    activeChip:
      "border-slate-500/50 bg-slate-500/10 text-slate-600 dark:text-slate-400",
  },
};

/** Bilinmeyen statüler için nötr görünüm */
export const FALLBACK_STATUS_BADGE =
  "bg-slate-500/10 text-slate-600 dark:bg-slate-500/15 dark:text-slate-400";
